import {Rating} from 'components/Rating';
import {Typography} from 'components/Typography';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {REVIEWS_CODE} from 'modules/product-card/constants';
import {selectProductData} from 'modules/product-card/selectors';
import {PLURAL_GRADE_WORDS} from 'modules/products/constants';
import {pluralReviewsText} from 'modules/products/utils';
import classNames from 'classnames';
import {FC, useMemo} from 'react';
import style from './style.module.scss';

export const ProductRating: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {ratings, reviewsCount} = productData || {};

    const reviewRating = useMemo(() => {
        return ratings?.find(({code}) => REVIEWS_CODE === code)?.value ?? 0;
    }, [ratings]);

    return (
        <div className={classNames(style.main, {[style.noReviews]: 0 >= (reviewsCount ?? 0)})}>
            {/* {0 < (reviewsCount ?? 0) && (*/}
            {/*    <Typography data-skeleton-item variant="label-14-r">*/}
            {/*        Рейтинг SW*/}
            {/*    </Typography>*/}
            {/* )}*/}
            <a className={style.ratingBody} data-skeleton-item={true} href={'#reviews'}>
                <Rating className={style.ratingComponent} isReadOnly={true} rate={reviewRating} />
                <Typography className={style.ratingReviewText} variant={'label-14-m'}>
                    {pluralReviewsText({
                        count: reviewsCount,
                        words: PLURAL_GRADE_WORDS,
                    })}
                </Typography>
                <Typography className={style.noReviewsText} variant={'label-14-m'}>
                    Оставить отзыв
                </Typography>
            </a>
        </div>
    );
};
